import { handleActions } from "redux-actions";

import {
    getUserAgents,
    getUserAgentsSuccess,
    getUserAgentsError,
    setSelectedUserAgents,
    setAddUserAgentDialog,
    mergeAddUserAgentDialog,
    clearUserAgents
} from "modules/UserAgents/services/UserAgents/actions";

const initialState = {
    isLoading: false,
    ids: [],
    userAgents: [],
    selectedUserAgents: [],
    count: 0,
    addUserAgentDialog: { 
        isOpen: false,
        isLoading: false
    }
};

export const userAgentsEntriesReducer = handleActions(
    {
        [clearUserAgents]: () => ({ ...initialState }),
        [getUserAgents]: (state) => ({
            ...state,
            ids: [],
            userAgents: [],
            selectedUserAgents: [],
            count: 0,
            isLoading: true
        }),
        [getUserAgentsSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getUserAgentsError]: (state) => ({
            ...state,
            isLoading: false
        }),

        [setSelectedUserAgents]: (state, { payload }) => ({
            ...state,
            selectedUserAgents: payload
        }),

        [setAddUserAgentDialog]: (state, { payload }) => ({
            ...state,
            addUserAgentDialog: {
                ...initialState.addUserAgentDialog,
                ...payload
            }
        }),
        [mergeAddUserAgentDialog]: (state, { payload }) => ({
            ...state,
            addUserAgentDialog: {
                ...state.addUserAgentDialog,
                ...payload
            }
        })
    },
    initialState
);
